module.exports = __webpack_public_path__ + "img/1.72d0677f.jpg";